import { useState } from "react";
import { toast } from "react-toastify";
import adManagerbackend from "../../../../../../api/api3";

const useSampleUpload = () => {
  const [isSampleUploading, setIsSampleUploading] = useState(false);
  const uploadSample = async (file) => {
    try {
      setIsSampleUploading(true);
      const formData = new FormData();
      formData.append("galleryVideo", file);
      const { data } = await adManagerbackend.post("/ads/file", formData);
      if (data.error) {
        if (data.error.includes("File size exceeds")) {
          toast.error("File size exceeds the 500MB limit");
        } else {
          toast.error("Only mp4, m4p, m4v, avi, mov, gif, jpeg, jpg and png files are acceptable");
        }
      }
      toast.error()
      setIsSampleUploading(false);
      return data.locationArray[0].fileLocation;
    } catch (error) {
      setIsSampleUploading(false);
      // toast.error(
      //   "Only mp4 ,m4p, m4v, avi, mov, gif, jpeg, jpg and png files are acceptable"
      // );
      return "";
    }
  };

  return { isSampleUploading, uploadSample };
};

export default useSampleUpload;

